import React from 'react';
import { useNavigate } from 'react-router-dom';

// Shown when a user with NO active listings taps "I'm interested" (PedalDetails,
// SuggestedTradesStrip). Interest is a trade signal — the owner's next move is
// to look at what the sender has to offer, so with an empty pedalboard the
// signal goes nowhere. Rather than silently allowing it (or a bare disable),
// prompt the user to list a pedal first (Jason's call, 2026-08-20).
const ListPedalPromptModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px'
      }}
    >
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px', padding: '24px',
        maxWidth: '380px', width: '100%', textAlign: 'center',
        fontFamily: 'Nunito, sans-serif', boxSizing: 'border-box'
      }}>
        <div style={{ fontSize: '34px', marginBottom: '8px' }}>🎸</div>
        <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#1f2937' }}>
          List a pedal first
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#4b5563', lineHeight: 1.5 }}>
          Interest tells the owner you&rsquo;d like to trade — and their next
          step is to check out your pedalboard. List a pedal or two so they
          can see what you&rsquo;re bringing to the table.
        </p>
        <button
          type="button"
          onClick={() => { onClose(); navigate('/addpedal'); }}
          style={{
            backgroundColor: '#C9A227', color: '#fff', border: 'none',
            borderRadius: '25px', padding: '11px 32px', fontSize: '15px',
            fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
            display: 'block', margin: '0 auto 10px'
          }}
        >
          List a pedal
        </button>
        <button
          type="button"
          onClick={onClose}
          style={{
            background: 'none', border: 'none', color: '#6b7280',
            fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit',
            textDecoration: 'underline'
          }}
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default ListPedalPromptModal;
